import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

// single source of truth
import { servicesData } from "../data/servicesData";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showPrices, setShowPrices] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* hash scroll support */
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  const handleNavigate = (path) => {
    setIsOpen(false);
    setShowServices(false);
    setShowPrices(false);

    if (path.includes("#")) {
      const [base, hash] = path.split("#");
      navigate(base || "/");

      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 200);
      return;
    }

    if (path.startsWith("#")) {
      if (window.location.pathname === "/") {
        document.getElementById(path.replace("#", ""))?.scrollIntoView({
          behavior: "smooth",
        });
      } else {
        navigate("/" + path);
      }
      return;
    }

    navigate(path);
  };

  return (
    <nav
      className={`navbar py-3 ${
        isOpen ? "custom-navbar" : "transparent-navbar"
      }`}
    >
      <div className="container d-flex justify-content-end align-items-center">
        {/* PÁLYÁZATI INFOBLOKK (homepage only) */}
        {location.pathname === "/" && (
          <a
            href="/INFOBLOKK.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-infoblokk"
          >
            <img
              src="/kedvezmenyezetti-infoblokk-keretes.jpg"
              alt="Pályázati tájékoztató – a részletek megnyitása PDF-ben"
            />
          </a>
        )}

        {/* MOBILE TOGGLE */}
        <button
          className="menu-toggle-btn d-md-none"
          aria-label="Menü"
          onClick={() => setIsOpen((v) => !v)}
        >
          {isOpen ? "✕" : "☰"}
        </button>

        {/* DESKTOP NAV */}
        {!isOpen && (
          <ul className="nav d-none d-md-flex align-items-center">
            {/* FŐOLDAL */}
            <li className="nav-item px-2" onClick={() => handleNavigate("/")}>
              Főoldal
            </li>

            {/* KEZELÉSEK */}
            <li className="nav-item px-2 position-relative">
              <span className="nav-dropdown-trigger">
                Kezelések <FaChevronDown className="nav-chevron" />
              </span>
              <ul className="custom-dropdown">
                {servicesData.map((service) => (
                  <li
                    key={service.slug}
                    className="custom-dropdown-item"
                    onClick={() => handleNavigate(service.path)}
                  >
                    {service.hero.title}
                  </li>
                ))}
              </ul>
            </li>

            {/* ÁRAK */}
            <li className="nav-item px-2 position-relative">
              <span className="nav-dropdown-trigger">
                Árak <FaChevronDown className="nav-chevron" />
              </span>
              <ul className="custom-dropdown">
                {servicesData.map((service) => (
                  <li
                    key={service.slug}
                    className="custom-dropdown-item"
                    onClick={() => handleNavigate(service.path + "#prices")}
                  >
                    {service.hero.title}
                  </li>
                ))}
              </ul>
            </li>

            <li
              className="nav-item px-2"
              onClick={() => handleNavigate("#gallery")}
            >
              Rendelőnk
            </li>

            <li
              className="nav-item px-2"
              onClick={() => handleNavigate("#contact")}
            >
              Kapcsolat
            </li>
          </ul>
        )}
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <div className="mobile-menu d-md-none">
          <ul>
            {/* FŐOLDAL */}
            <li onClick={() => handleNavigate("/")}>Főoldal</li>

            {/* KEZELÉSEK */}
            <li
              className="mobile-has-sub"
              onClick={() => setShowServices((v) => !v)}
            >
              Kezelések <FaChevronDown className="mobile-chevron" />
            </li>

            {showServices &&
              servicesData.map((service) => (
                <li
                  key={service.slug}
                  className="mobile-sub"
                  onClick={() => handleNavigate(service.path)}
                >
                  {service.hero.title}
                </li>
              ))}

            {/* ÁRAK */}
            <li
              className="mobile-has-sub"
              onClick={() => setShowPrices((v) => !v)}
            >
              Árak <FaChevronDown className="mobile-chevron" />
            </li>

            {showPrices &&
              servicesData.map((service) => (
                <li
                  key={service.slug}
                  className="mobile-sub"
                  onClick={() => handleNavigate(service.path + "#prices")}
                >
                  {service.hero.title}
                </li>
              ))}

            <li onClick={() => handleNavigate("#gallery")}>Rendelőnk</li>
            <li onClick={() => handleNavigate("#contact")}>Kapcsolat</li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
